import _page_0 from '/app/src/pages/index/index.vue'
import _page_1 from '/app/src/pages/[...path].vue'
import _page_2 from '/app/src/pages/403.vue'
import _page_3 from '/app/src/pages/500.vue'
import _page_4 from '/app/src/pages/503.vue'
import _page_5 from '/app/src/pages/branches/index.vue'
import _page_6 from '/app/src/pages/branches/[id].vue'
import _page_7 from '/app/src/pages/branches/new.vue'
import _page_8 from '/app/src/pages/callHistory/index.vue'
import _page_9 from '/app/src/pages/customerAnnouncement/index.vue'
import _page_10 from '/app/src/pages/customerAnnouncement/[id].vue'
import _page_11 from '/app/src/pages/customerAnnouncement/new.vue'
import _page_12 from '/app/src/pages/customers/index.vue'
import _page_13 from '/app/src/pages/customers/[id].vue'
import _page_14 from '/app/src/pages/customers/edit.vue'
import _page_15 from '/app/src/pages/customers/new.vue'
import _page_16 from '/app/src/pages/departments/index.vue'
import _page_17 from '/app/src/pages/departments/[id].vue'
import _page_18 from '/app/src/pages/departments/new.vue'
import _page_19 from '/app/src/pages/editProfile/index.vue'
import _page_20 from '/app/src/pages/employeeAnnouncement/index.vue'
import _page_21 from '/app/src/pages/employeeAnnouncement/[id].vue'
import _page_22 from '/app/src/pages/employeeAnnouncement/new.vue'
import _page_23 from '/app/src/pages/employees/index.vue'
import _page_24 from '/app/src/pages/employees/[id].vue'
import _page_25 from '/app/src/pages/employees/new.vue'
import _page_26 from '/app/src/pages/expired.vue'
import _page_27 from '/app/src/pages/kb/index.vue'
import _page_28 from '/app/src/pages/kb/articles/[id].vue'
import _page_29 from '/app/src/pages/kb/articles/[id]/[slug].vue'
import _page_30 from '/app/src/pages/kb/categories/[id].vue'
import _page_31 from '/app/src/pages/knowledgeBaseArticles/index.vue'
import _page_32 from '/app/src/pages/knowledgeBaseArticles/[id].vue'
import _page_33 from '/app/src/pages/knowledgeBaseCategories/index.vue'
import _page_34 from '/app/src/pages/log/index.vue'
import _page_35 from '/app/src/pages/login/index.vue'
import _page_36 from '/app/src/pages/organization/index.vue'
import _page_37 from '/app/src/pages/organization/[id].vue'
import _page_38 from '/app/src/pages/organization/new.vue'
import _page_39 from '/app/src/pages/report/index.vue'
import _page_40 from '/app/src/pages/settings/index.vue'
import _page_41 from '/app/src/pages/settings/customerCustomFields/index.vue'
import _page_42 from '/app/src/pages/settings/customerEvents/index.vue'
import _page_43 from '/app/src/pages/settings/customerLevel/index.vue'
import _page_44 from '/app/src/pages/settings/customerLevel/[id].vue'
import _page_45 from '/app/src/pages/settings/customerLevel/new.vue'
import _page_46 from '/app/src/pages/settings/customFields/index.vue'
import _page_47 from '/app/src/pages/settings/emailToTicketSettings/index.vue'
import _page_48 from '/app/src/pages/settings/forms/index.vue'
import _page_49 from '/app/src/pages/settings/forms/[id].vue'
import _page_50 from '/app/src/pages/settings/forms/new.vue'
import _page_51 from '/app/src/pages/settings/generalNoticeSettings/index.vue'
import _page_52 from '/app/src/pages/settings/generalTicketSettings/index.vue'
import _page_53 from '/app/src/pages/settings/knowledgeBaseSettings/index.vue'
import _page_54 from '/app/src/pages/settings/knowledgebaseTemplate/index.vue'
import _page_55 from '/app/src/pages/settings/knowledgebaseTemplate/[id].vue'
import _page_56 from '/app/src/pages/settings/knowledgebaseTemplate/new.vue'
import _page_57 from '/app/src/pages/settings/notice/index.vue'
import _page_58 from '/app/src/pages/settings/offDays/index.vue'
import _page_59 from '/app/src/pages/settings/organizationCustomFields/index.vue'
import _page_60 from '/app/src/pages/settings/plugins/index.vue'
import _page_61 from '/app/src/pages/settings/plugins/[slug].vue'
import _page_62 from '/app/src/pages/settings/securitySettings/index.vue'
import _page_63 from '/app/src/pages/settings/services/index.vue'
import _page_64 from '/app/src/pages/settings/services/[id].vue'
import _page_65 from '/app/src/pages/settings/services/new.vue'
import _page_66 from '/app/src/pages/settings/sla/index.vue'
import _page_67 from '/app/src/pages/settings/sla/[id].vue'
import _page_68 from '/app/src/pages/settings/sla/new.vue'
import _page_69 from '/app/src/pages/settings/systemInformation/index.vue'
import _page_70 from '/app/src/pages/settings/tags/index.vue'
import _page_71 from '/app/src/pages/settings/ticketCategory/index.vue'
import _page_72 from '/app/src/pages/settings/ticketCategory/[id].vue'
import _page_73 from '/app/src/pages/settings/ticketCategory/new.vue'
import _page_74 from '/app/src/pages/settings/ticketForms/index.vue'
import _page_75 from '/app/src/pages/settings/ticketForms/[id].vue'
import _page_76 from '/app/src/pages/settings/ticketForms/new.vue'
import _page_77 from '/app/src/pages/settings/ticketTemplates/index.vue'
import _page_78 from '/app/src/pages/settings/ticketTemplates/[id].vue'
import _page_79 from '/app/src/pages/settings/ticketTemplates/new.vue'
import _page_80 from '/app/src/pages/settings/userAccountSettings/index.vue'
import _page_81 from '/app/src/pages/settings/workingShift/index.vue'
import _page_82 from '/app/src/pages/settings/workingShift/[id].vue'
import _page_83 from '/app/src/pages/settings/workingShift/new.vue'
import _page_84 from '/app/src/pages/signup/index.vue'
import _page_85 from '/app/src/pages/tickets/index.vue'
import _page_86 from '/app/src/pages/tickets/[id].vue'
import _page_87 from '/app/src/pages/tickets/fromCustomer.vue'
import _page_88 from '/app/src/pages/tickets/new.vue'

export const routes = [
  {
    path: '/',
    /* internal name: '/' */
    /* no component */
    children: [
      {
        path: '',
        name: '//',
        component: _page_0,
        /* no children */
      }
    ],
  },
  {
    path: '/:path(.*)',
    name: '/[...path]',
    component: _page_1,
    /* no children */
  },
  {
    path: '/403',
    name: '/403',
    component: _page_2,
    /* no children */
  },
  {
    path: '/500',
    name: '/500',
    component: _page_3,
    /* no children */
  },
  {
    path: '/503',
    name: '/503',
    component: _page_4,
    /* no children */
  },
  {
    path: '/branches',
    /* internal name: '/branches' */
    /* no component */
    children: [
      {
        path: '',
        name: '/branches/',
        component: _page_5,
        /* no children */
      },
      {
        path: ':id',
        name: '/branches/[id]',
        component: _page_6,
        /* no children */
      },
      {
        path: 'new',
        name: '/branches/new',
        component: _page_7,
        /* no children */
      }
    ],
  },
  {
    path: '/callHistory',
    /* internal name: '/callHistory' */
    /* no component */
    children: [
      {
        path: '',
        name: '/callHistory/',
        component: _page_8,
        /* no children */
      }
    ],
  },
  {
    path: '/customerAnnouncement',
    /* internal name: '/customerAnnouncement' */
    /* no component */
    children: [
      {
        path: '',
        name: '/customerAnnouncement/',
        component: _page_9,
        /* no children */
      },
      {
        path: ':id',
        name: '/customerAnnouncement/[id]',
        component: _page_10,
        /* no children */
      },
      {
        path: 'new',
        name: '/customerAnnouncement/new',
        component: _page_11,
        /* no children */
      }
    ],
  },
  {
    path: '/customers',
    /* internal name: '/customers' */
    /* no component */
    children: [
      {
        path: '',
        name: '/customers/',
        component: _page_12,
        /* no children */
      },
      {
        path: ':id',
        name: '/customers/[id]',
        component: _page_13,
        /* no children */
      },
      {
        path: 'edit',
        name: '/customers/edit',
        component: _page_14,
        /* no children */
      },
      {
        path: 'new',
        name: '/customers/new',
        component: _page_15,
        /* no children */
      }
    ],
  },
  {
    path: '/departments',
    /* internal name: '/departments' */
    /* no component */
    children: [
      {
        path: '',
        name: '/departments/',
        component: _page_16,
        /* no children */
      },
      {
        path: ':id',
        name: '/departments/[id]',
        component: _page_17,
        /* no children */
      },
      {
        path: 'new',
        name: '/departments/new',
        component: _page_18,
        /* no children */
      }
    ],
  },
  {
    path: '/editProfile',
    /* internal name: '/editProfile' */
    /* no component */
    children: [
      {
        path: '',
        name: '/editProfile/',
        component: _page_19,
        /* no children */
      }
    ],
  },
  {
    path: '/employeeAnnouncement',
    /* internal name: '/employeeAnnouncement' */
    /* no component */
    children: [
      {
        path: '',
        name: '/employeeAnnouncement/',
        component: _page_20,
        /* no children */
      },
      {
        path: ':id',
        name: '/employeeAnnouncement/[id]',
        component: _page_21,
        /* no children */
      },
      {
        path: 'new',
        name: '/employeeAnnouncement/new',
        component: _page_22,
        /* no children */
      }
    ],
  },
  {
    path: '/employees',
    /* internal name: '/employees' */
    /* no component */
    children: [
      {
        path: '',
        name: '/employees/',
        component: _page_23,
        /* no children */
      },
      {
        path: ':id',
        name: '/employees/[id]',
        component: _page_24,
        /* no children */
      },
      {
        path: 'new',
        name: '/employees/new',
        component: _page_25,
        /* no children */
      }
    ],
  },
  {
    path: '/expired',
    name: '/expired',
    component: _page_26,
    /* no children */
  },
  {
    path: '/kb',
    /* internal name: '/kb' */
    /* no component */
    children: [
      {
        path: '',
        name: '/kb/',
        component: _page_27,
        /* no children */
      },
      {
        path: 'articles',
        /* internal name: '/kb/articles' */
        /* no component */
        children: [
          {
            path: ':id',
            name: '/kb/articles/[id]',
            component: _page_28,
            children: [
              {
                path: ':slug',
                name: '/kb/articles/[id]/[slug]',
                component: _page_29,
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'categories',
        /* internal name: '/kb/categories' */
        /* no component */
        children: [
          {
            path: ':id',
            name: '/kb/categories/[id]',
            component: _page_30,
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/knowledgeBaseArticles',
    /* internal name: '/knowledgeBaseArticles' */
    /* no component */
    children: [
      {
        path: '',
        name: '/knowledgeBaseArticles/',
        component: _page_31,
        /* no children */
      },
      {
        path: ':id',
        name: '/knowledgeBaseArticles/[id]',
        component: _page_32,
        /* no children */
      }
    ],
  },
  {
    path: '/knowledgeBaseCategories',
    /* internal name: '/knowledgeBaseCategories' */
    /* no component */
    children: [
      {
        path: '',
        name: '/knowledgeBaseCategories/',
        component: _page_33,
        /* no children */
      }
    ],
  },
  {
    path: '/log',
    /* internal name: '/log' */
    /* no component */
    children: [
      {
        path: '',
        name: '/log/',
        component: _page_34,
        /* no children */
      }
    ],
  },
  {
    path: '/login',
    /* internal name: '/login' */
    /* no component */
    children: [
      {
        path: '',
        name: '/login/',
        component: _page_35,
        /* no children */
      }
    ],
  },
  {
    path: '/organization',
    /* internal name: '/organization' */
    /* no component */
    children: [
      {
        path: '',
        name: '/organization/',
        component: _page_36,
        /* no children */
      },
      {
        path: ':id',
        name: '/organization/[id]',
        component: _page_37,
        /* no children */
      },
      {
        path: 'new',
        name: '/organization/new',
        component: _page_38,
        /* no children */
      }
    ],
  },
  {
    path: '/report',
    /* internal name: '/report' */
    /* no component */
    children: [
      {
        path: '',
        name: '/report/',
        component: _page_39,
        /* no children */
      }
    ],
  },
  {
    path: '/settings',
    /* internal name: '/settings' */
    /* no component */
    children: [
      {
        path: '',
        name: '/settings/',
        component: _page_40,
        /* no children */
      },
      {
        path: 'customerCustomFields',
        /* internal name: '/settings/customerCustomFields' */
        /* no component */
        children: [
          {
            path: '',
            name: '/settings/customerCustomFields/',
            component: _page_41,
            /* no children */
          }
        ],
      },
      {
        path: 'customerEvents',
        /* internal name: '/settings/customerEvents' */
        /* no component */
        children: [
          {
            path: '',
            name: '/settings/customerEvents/',
            component: _page_42,
            /* no children */
          }
        ],
      },
      {
        path: 'customerLevel',
        /* internal name: '/settings/customerLevel' */
        /* no component */
        children: [
          {
            path: '',
            name: '/settings/customerLevel/',
            component: _page_43,
            /* no children */
          },
          {
            path: ':id',
            name: '/settings/customerLevel/[id]',
            component: _page_44,
            /* no children */
          },
          {
            path: 'new',
            name: '/settings/customerLevel/new',
            component: _page_45,
            /* no children */
          }
        ],
      },
      {
        path: 'customFields',
        /* internal name: '/settings/customFields' */
        /* no component */
        children: [
          {
            path: '',
            name: '/settings/customFields/',
            component: _page_46,
            /* no children */
          }
        ],
      },
      {
        path: 'emailToTicketSettings',
        /* internal name: '/settings/emailToTicketSettings' */
        /* no component */
        children: [
          {
            path: '',
            name: '/settings/emailToTicketSettings/',
            component: _page_47,
            /* no children */
          }
        ],
      },
      {
        path: 'forms',
        /* internal name: '/settings/forms' */
        /* no component */
        children: [
          {
            path: '',
            name: '/settings/forms/',
            component: _page_48,
            /* no children */
          },
          {
            path: ':id',
            name: '/settings/forms/[id]',
            component: _page_49,
            /* no children */
          },
          {
            path: 'new',
            name: '/settings/forms/new',
            component: _page_50,
            /* no children */
          }
        ],
      },
      {
        path: 'generalNoticeSettings',
        /* internal name: '/settings/generalNoticeSettings' */
        /* no component */
        children: [
          {
            path: '',
            name: '/settings/generalNoticeSettings/',
            component: _page_51,
            /* no children */
          }
        ],
      },
      {
        path: 'generalTicketSettings',
        /* internal name: '/settings/generalTicketSettings' */
        /* no component */
        children: [
          {
            path: '',
            name: '/settings/generalTicketSettings/',
            component: _page_52,
            /* no children */
          }
        ],
      },
      {
        path: 'knowledgeBaseSettings',
        /* internal name: '/settings/knowledgeBaseSettings' */
        /* no component */
        children: [
          {
            path: '',
            name: '/settings/knowledgeBaseSettings/',
            component: _page_53,
            /* no children */
          }
        ],
      },
      {
        path: 'knowledgebaseTemplate',
        /* internal name: '/settings/knowledgebaseTemplate' */
        /* no component */
        children: [
          {
            path: '',
            name: '/settings/knowledgebaseTemplate/',
            component: _page_54,
            /* no children */
          },
          {
            path: ':id',
            name: '/settings/knowledgebaseTemplate/[id]',
            component: _page_55,
            /* no children */
          },
          {
            path: 'new',
            name: '/settings/knowledgebaseTemplate/new',
            component: _page_56,
            /* no children */
          }
        ],
      },
      {
        path: 'notice',
        /* internal name: '/settings/notice' */
        /* no component */
        children: [
          {
            path: '',
            name: '/settings/notice/',
            component: _page_57,
            /* no children */
          }
        ],
      },
      {
        path: 'offDays',
        /* internal name: '/settings/offDays' */
        /* no component */
        children: [
          {
            path: '',
            name: '/settings/offDays/',
            component: _page_58,
            /* no children */
          }
        ],
      },
      {
        path: 'organizationCustomFields',
        /* internal name: '/settings/organizationCustomFields' */
        /* no component */
        children: [
          {
            path: '',
            name: '/settings/organizationCustomFields/',
            component: _page_59,
            /* no children */
          }
        ],
      },
      {
        path: 'plugins',
        /* internal name: '/settings/plugins' */
        /* no component */
        children: [
          {
            path: '',
            name: '/settings/plugins/',
            component: _page_60,
            /* no children */
          },
          {
            path: ':slug',
            name: '/settings/plugins/[slug]',
            component: _page_61,
            /* no children */
          }
        ],
      },
      {
        path: 'securitySettings',
        /* internal name: '/settings/securitySettings' */
        /* no component */
        children: [
          {
            path: '',
            name: '/settings/securitySettings/',
            component: _page_62,
            /* no children */
          }
        ],
      },
      {
        path: 'services',
        /* internal name: '/settings/services' */
        /* no component */
        children: [
          {
            path: '',
            name: '/settings/services/',
            component: _page_63,
            /* no children */
          },
          {
            path: ':id',
            name: '/settings/services/[id]',
            component: _page_64,
            /* no children */
          },
          {
            path: 'new',
            name: '/settings/services/new',
            component: _page_65,
            /* no children */
          }
        ],
      },
      {
        path: 'sla',
        /* internal name: '/settings/sla' */
        /* no component */
        children: [
          {
            path: '',
            name: '/settings/sla/',
            component: _page_66,
            /* no children */
          },
          {
            path: ':id',
            name: '/settings/sla/[id]',
            component: _page_67,
            /* no children */
          },
          {
            path: 'new',
            name: '/settings/sla/new',
            component: _page_68,
            /* no children */
          }
        ],
      },
      {
        path: 'systemInformation',
        /* internal name: '/settings/systemInformation' */
        /* no component */
        children: [
          {
            path: '',
            name: '/settings/systemInformation/',
            component: _page_69,
            /* no children */
          }
        ],
      },
      {
        path: 'tags',
        /* internal name: '/settings/tags' */
        /* no component */
        children: [
          {
            path: '',
            name: '/settings/tags/',
            component: _page_70,
            /* no children */
          }
        ],
      },
      {
        path: 'ticketCategory',
        /* internal name: '/settings/ticketCategory' */
        /* no component */
        children: [
          {
            path: '',
            name: '/settings/ticketCategory/',
            component: _page_71,
            /* no children */
          },
          {
            path: ':id',
            name: '/settings/ticketCategory/[id]',
            component: _page_72,
            /* no children */
          },
          {
            path: 'new',
            name: '/settings/ticketCategory/new',
            component: _page_73,
            /* no children */
          }
        ],
      },
      {
        path: 'ticketForms',
        /* internal name: '/settings/ticketForms' */
        /* no component */
        children: [
          {
            path: '',
            name: '/settings/ticketForms/',
            component: _page_74,
            /* no children */
          },
          {
            path: ':id',
            name: '/settings/ticketForms/[id]',
            component: _page_75,
            /* no children */
          },
          {
            path: 'new',
            name: '/settings/ticketForms/new',
            component: _page_76,
            /* no children */
          }
        ],
      },
      {
        path: 'ticketTemplates',
        /* internal name: '/settings/ticketTemplates' */
        /* no component */
        children: [
          {
            path: '',
            name: '/settings/ticketTemplates/',
            component: _page_77,
            /* no children */
          },
          {
            path: ':id',
            name: '/settings/ticketTemplates/[id]',
            component: _page_78,
            /* no children */
          },
          {
            path: 'new',
            name: '/settings/ticketTemplates/new',
            component: _page_79,
            /* no children */
          }
        ],
      },
      {
        path: 'userAccountSettings',
        /* internal name: '/settings/userAccountSettings' */
        /* no component */
        children: [
          {
            path: '',
            name: '/settings/userAccountSettings/',
            component: _page_80,
            /* no children */
          }
        ],
      },
      {
        path: 'workingShift',
        /* internal name: '/settings/workingShift' */
        /* no component */
        children: [
          {
            path: '',
            name: '/settings/workingShift/',
            component: _page_81,
            /* no children */
          },
          {
            path: ':id',
            name: '/settings/workingShift/[id]',
            component: _page_82,
            /* no children */
          },
          {
            path: 'new',
            name: '/settings/workingShift/new',
            component: _page_83,
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/signup',
    /* internal name: '/signup' */
    /* no component */
    children: [
      {
        path: '',
        name: '/signup/',
        component: _page_84,
        /* no children */
      }
    ],
  },
  {
    path: '/tickets',
    /* internal name: '/tickets' */
    /* no component */
    children: [
      {
        path: '',
        name: '/tickets/',
        component: _page_85,
        /* no children */
      },
      {
        path: ':id',
        name: '/tickets/[id]',
        component: _page_86,
        /* no children */
      },
      {
        path: 'fromCustomer',
        name: '/tickets/fromCustomer',
        component: _page_87,
        /* no children */
      },
      {
        path: 'new',
        name: '/tickets/new',
        component: _page_88,
        /* no children */
      }
    ],
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

